import type { RunSummary } from "../api/types";

/**
 * Surfaces `RunSummary.error_summary` when the run was auto-paused
 * (today: OpenAI quota exhaustion). Renders nothing when the run is
 * not paused or no reason was stamped — caller doesn't need to guard.
 * `className` lets callers add margin/layout without re-wrapping.
 */
export function PauseErrorBanner({
  run,
  className,
}: {
  run: RunSummary;
  className?: string;
}) {
  if (run.producer_status !== "paused" || !run.error_summary) return null;
  return (
    <div
      className={`rounded-md border border-warn/30 bg-warn/10 px-3 py-2 text-xs text-warn ${className ?? ""}`}
    >
      <span className="font-medium">Auto-paused:</span>{" "}
      <span className="text-fg/80">{run.error_summary}</span>
    </div>
  );
}
